import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import templateServices from '../../services/TemplateServices';
import { autorun } from 'mobx';
import Utils from '../../common/Utils';
//import { withRouter } from 'react-router-dom';
import withRouter from '../../common/decorator/withRouter';
import { EVENT } from '../../common/events/listEvents';
import { OddsFormat } from '../../common/Foundation';
import UrlListenerComponent from '../UrlListenerComponent';
import { isEmpty } from 'lodash';

@inject('LayoutTemplateStore', 'AccountStore', 'SportsStore', 'OddspageStore')
@observer
class HeaderComponent extends Component {
  constructor(props) {
    super(props);
    this.AccountStore = this.props.AccountStore;
    this.LayoutTemplateStore = this.props.LayoutTemplateStore;
    this.SportsStore = this.props.SportsStore;
    this.OddspageStore = this.props.OddspageStore;
    this.state = {
      comps: null,
       currentViewContainer: ""
    }
    this.getClassName = this.getClassName.bind(this)
    this.updateMaxBetPreferenceSettingBase = this.updateMaxBetPreferenceSettingBase.bind(this)

  }

  componentDidMount() {
    window.listenEvent(EVENT.FIRST_LOGIN, this.actionWithFirstLogin);
    window.listenEvent(EVENT.UPDATE_MAX_BET_PREFERENCE_SETTING_BASE, this.updateMaxBetPreferenceSettingBase);
    this.autorun = autorun(() => {

      let currentViewContainer = this.LayoutTemplateStore.currentViewContainer;
      if (this.state.currentViewContainer !== currentViewContainer) {
        let dataComps = [];
        if (this.LayoutTemplateStore.templateData.headerContainer != null) {
          let componentsByView = this.LayoutTemplateStore.templateData.headerContainer[currentViewContainer];
          if (componentsByView != null && componentsByView.length > 0) {
            dataComps = componentsByView || [];
          } else {
            dataComps = this.LayoutTemplateStore.templateData.headerContainer.formal || []
          }

        }

        this.setState({
          comps: templateServices.listComponentsByData(dataComps, this.AccountStore.isAuth, this.props.router) || null,
          currentViewContainer: currentViewContainer
        });
      }

    });
  }

  componentWillUnmount() {
    this.autorun();
    window.stopListenEvent(EVENT.FIRST_LOGIN, this.actionWithFirstLogin);
    window.stopListenEvent(EVENT.UPDATE_MAX_BET_PREFERENCE_SETTING_BASE, this.updateMaxBetPreferenceSettingBase);
  }

  updateMaxBetPreferenceSettingBase() {
    this.AccountStore.updateUser({maxBetPreferenceSettingBase: true});
    // For Europe view
    // -- For Feature page
    this.SportsStore.updateOption('oddsFormat', OddsFormat.AM);
    // -- For Odds page
    let oddsPageInitData = JSON.parse(JSON.stringify(this.OddspageStore.oddsPageInitData));
    oddsPageInitData.oddsFormat = OddsFormat.AM;
    this.OddspageStore.updateOddsPageInitData(oddsPageInitData);
  }



  actionWithFirstLogin = () => {
	if(window.location.href.indexOf('ngc') === -1 
      && window.location.href.indexOf('change-password') === -1) {
      let viewPath = '';
      let viewOnURL = Utils.getViewPathByURLPath();
      if (viewOnURL === 'asian') {
        viewPath = '/' + Utils.getCurrentLang() + '/' + viewOnURL + '/tc-page';
        this.props.history.push(viewPath);
        return;
      }
      this.props.history.push('/' + Utils.getUserLanguage() + '/tc-page');
    }
  }


  getClassName() {
    const { hasNewMessage, isAuth } = this.AccountStore;
    return ` ${isAuth ? 'auth' : ''} ${hasNewMessage ? 'hasMess' : ''}`;
  }

  render() {
    const themeDefaultB2BArcadia = Utils.themeDefaultB2BArcadia();
    return (
      <React.Fragment>
        <div id="page-header" className={themeDefaultB2BArcadia +" page-header " + this.getClassName()}>
          <div className="top-header container-fluid">
            {this.state.comps}   
            <UrlListenerComponent 
              onUrlChange={()=>{
                if(!isEmpty(window.env.sportsGamesMetaData) && Utils.isPA()) Utils.updateMetaData()
              }}/>
          </div>      
        </div>
       
      </React.Fragment>
    )
  }
}

export default withRouter(HeaderComponent);


// WEBPACK FOOTER //
// ./src/app/components/HeaderComponent/index.js